<template>
  <div>
    <el-input
      placeholder="0.00"
      v-model.lazy="displayValue"
      clearable
      @blur="isInputActive = false"
      @focus="isInputActive = true"
      @keypress.native="checkInput"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "currency-input",
  props: ["value"],
  data() {
    return {
      isInputActive: false
    };
  },
  methods: {
    checkInput(event) {
      if (
        ((event.which != 46 || event.target.value.indexOf(".") != -1) &&
          (event.which < 48 || event.which > 57)) ||
        (event.which == 46 && event.target.selectionStart == 0)
      ) {
        event.preventDefault();
      }
    },
    isInt(n) {
      return Number(n) === n && n % 1 === 0;
    },
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
  },
  computed: {
    displayValue: {
      get() {
        if (this.isInputActive) {
          return this.value.toString();
        } else {
          let fixed = this.value
            ? parseFloat(this.value)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")
            : "";
          return fixed;
        }
      },
      set(newvalue) {
        if (this.isFloat(parseFloat(newvalue))) {
          newvalue = newvalue.substring(0, newvalue.indexOf(".") + 3);
        }
        let nv = newvalue.replace(/^0+/, "0");
        nv = nv.replace(/\.0{3,}$/, ".00");
        if (isNaN(nv)) {
          nv = "";
        }
        this.$emit("changeValue");
        this.$emit("input", nv);
      }
    }
  }
};
</script>
